
import { Component, Mixins } from 'vue-property-decorator';
import SidenaviRewardClub from '.';
import { isVisibleLineBanner } from '@/lib/functions';
import store from '@/store';
const Words: Dictionary = {
  label: 'ポイントが貯まってさらにお得',
};
@Component
export default class SidenaviRewardClubJa extends Mixins(SidenaviRewardClub) {
  private words = Words;

  get isGroup(): boolean {
    return this.$store.getters['auth/group'];
  }

  get visibleRewardsClubBanner(): boolean {
    return isVisibleLineBanner({
      lang: store.getters['auth/lang'],
      group: store.getters['auth/group'],
    });
  }
}
